export type SupportedLocaleIds = typeof supportedLocaleIds;
export type LocaleId = SupportedLocaleIds[number];

export const supportedLocaleIds = ["en-au", "en-ca", "en-gb", "en-us"] as const;

// biome-ignore lint/suspicious/noExplicitAny: allow any value as parameter
export const isSupportedLocaleId = (localeId: any): localeId is LocaleId => {
	return localeId && supportedLocaleIds.includes(localeId);
};

export interface LocaleConfig {
	localeId: LocaleId;
	currencyCode: string;
	appUrl: string | undefined;
	pathPrefix: string | undefined;
	portalUrl?: string;
	webflowHomepageUrl: string;
}

export type LocaleConfigMap = Record<LocaleId, LocaleConfig>;

export const localeByLocaleId: LocaleConfigMap = {
	"en-au": {
		localeId: "en-au",
		appUrl: process.env.REACT_APP_AU_APP_URL,
		portalUrl: process.env.REACT_APP_PORTAL_AU_HOSTNAME,
		currencyCode: "AUD",
		pathPrefix: process.env.REACT_APP_AU_PATH_PREFIX ?? "",
		webflowHomepageUrl:
			process.env.REACT_APP_WEBFLOW_AU_HOMEPAGE_URL ??
			`${process.env.REACT_APP_WEBFLOW_US_HOMEPAGE_URL}/${process.env.REACT_APP_AU_PATH_PREFIX}`,
	},
	"en-ca": {
		localeId: "en-ca",
		appUrl: process.env.REACT_APP_CA_APP_URL,
		portalUrl: process.env.REACT_APP_PORTAL_CA_HOSTNAME,
		currencyCode: "CAD",
		pathPrefix: process.env.REACT_APP_CA_PATH_PREFIX ?? "",
		webflowHomepageUrl:
			process.env.REACT_APP_WEBFLOW_CA_HOMEPAGE_URL ??
			`${process.env.REACT_APP_WEBFLOW_US_HOMEPAGE_URL}/${process.env.REACT_APP_CA_PATH_PREFIX}`,
	},
	"en-gb": {
		localeId: "en-gb",
		appUrl: process.env.REACT_APP_GB_APP_URL,
		portalUrl: `${process.env.REACT_APP_PORTAL_HOSTNAME}/en-gb`,
		currencyCode: "GBP",
		pathPrefix: "/en-gb",
		webflowHomepageUrl: `${process.env.REACT_APP_WEBFLOW_US_HOMEPAGE_URL}/en-gb`,
	},
	"en-us": {
		localeId: "en-us",
		appUrl: process.env.REACT_APP_US_APP_URL,
		portalUrl: process.env.REACT_APP_PORTAL_HOSTNAME,
		currencyCode: "USD",
		pathPrefix: "",
		webflowHomepageUrl: process.env.REACT_APP_WEBFLOW_US_HOMEPAGE_URL,
	},
};
